export const COUNTER_DATA = "counter";
export const CURRENT_INDEX = "index";